/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditcostgetcredits3Inputs */

const en_creditcostgetcredits3 = /** @type {(inputs: Creditcostgetcredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get more credits`)
};

const de_creditcostgetcredits3 = /** @type {(inputs: Creditcostgetcredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Credits holen`)
};

/**
* | output |
* | --- |
* | "Get more credits" |
*
* @param {Creditcostgetcredits3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcostgetcredits3 = /** @type {((inputs?: Creditcostgetcredits3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcostgetcredits3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcostgetcredits3(inputs)
	return de_creditcostgetcredits3(inputs)
});
export { creditcostgetcredits3 as "creditCostGetCredits" }